import { isOwner, ProjectFile } from 'entities';

import { Column, Row, Card, Tooltip } from 'components/Blocks';
import { DownloadFileButton } from 'components/Buttons';
import { TruncateText } from 'components/TruncateText';

import { SwapFileButton } from './SwapFileButton';
import { NewProjectFileVersion } from './NewFileVersion';

import { useUser } from 'hooks/user';
import { useProjectProfile } from '../../context';

import { dateDistanceToNow, formatPublishedAtDate } from 'utils/date';
import { fixFileName } from 'utils/text';

import { cn } from 'styles';
import { RenameFileButton } from './RenameFileButton';
import { FileVersionTag } from '../../FileHistoryTag';

interface ProjectFilesProps {
  file: ProjectFile;
}

export function SingleProjectFile({ file }: ProjectFilesProps) {
  const user = useUser();
  const { project } = useProjectProfile();

  const isProjectOwner = isOwner(project, user);

  return (
    <Card flow="row" key={file.id} justifyContent="space-between" className={cn('phone:flex-col')}>
      <Row gap="2" fullWidth>
        <Column gap="0.5">
          <Row gap="2">
            <TruncateText
              text={fixFileName(file.name)}
              max={45}
              className="font-medium text-primary"
            />

            <FileVersionTag file={file} />
          </Row>

          <Tooltip content={formatPublishedAtDate(file.uploadedAt)}>
            <span className="text-xs font-medium phone:text-xs">
              {dateDistanceToNow(file.updatedAt || file.uploadedAt)}
            </span>
          </Tooltip>
        </Column>
      </Row>

      <Row className="ml-auto" gap="2">
        {isProjectOwner && <RenameFileButton file={file} />}

        {isProjectOwner && <NewProjectFileVersion file={file} />}

        {isProjectOwner && <SwapFileButton file={file} />}

        {file.url && <DownloadFileButton size={16} {...file} />}
      </Row>
    </Card>
  );
}
